import React from "react";
import { ModalProps } from "react-bootstrap";
import { Container, Image } from "react-bootstrap";

import "./AppIsDownloadingModal.scss";
import ImageExplainer from "../../../../images/download-tutorial.gif";
import BottomModal from "../../../../components/BottomModal/BottomModal";
import GhostButton from "../../../../components/dashboard-page/GhostButton/GhostButton";
import ImageBackIcon from "../../../../images/arrow-left-black.svg";
import FixedFooter from "../../../../components/FixedFooter/FixedFooter";
import FilledButton, {
  ButtonSizes,
} from "../../../../components/dashboard-page/FilledButton/FilledButton";
import LoadingDots from "../../../../components/LoadingDots/LoadingDots";

function CircularContainer({ content }: { content: string }) {
  return (
    <div className="mx-2 circular-container ">
      <span className="circular-content-text">{content}</span>
    </div>
  );
}

interface AppIsDownloadingModalProps extends ModalProps {
  onHideParent?: (isGoBack?: boolean) => void;
}

function AppIsDownloadingModal({
  show,
  onHideParent,
}: AppIsDownloadingModalProps) {
  return (
    <BottomModal
      show={show}
      style={{ zIndex: 200, top: 0, background: "white" }}
    >
      <div className="MobileOnly position-relative app-is-dl-modal">
        <p className="d-flex mb-3 ps-2">
          <GhostButton
            aria-label="go back"
            onClick={() => onHideParent?.(true)}
            className="d-inline"
          >
            <Image src={ImageBackIcon} width={30} height={30} alt="back" />
          </GhostButton>{" "}
        </p>
        <div>
          <h1 className="title-text text-black d-flex justify-content-center">
            <span>Hyper App is Downloading</span>{" "}
            <LoadingDots containerStyles={{ paddingBottom: 4 }} />
          </h1>
          <Container fluid className="mt-3 instruction-row-container">
            <div className="circular-container-div">
              <CircularContainer content="1" />
            </div>
            <span className="mx-2 instruction-text">
              Wait for download to complete
            </span>
          </Container>
          <Container fluid className="mt-3 instruction-row-container">
            <div className="circular-container-div">
              <CircularContainer content="2" />
            </div>
            <span className="mx-2 instruction-text">
              Open download folder and tap the file to install Hyper
            </span>
          </Container>
          <Container fluid className="mt-3 instruction-row-container">
            <div className="circular-container-div">
              <CircularContainer content="3" />
            </div>
            <span className="mx-2 instruction-text">
              Continue to sign up while Hyper app is downloading
            </span>
          </Container>
          <div className="flex-column d-flex justify-content-center px-3 mt-5  explainer-container">
            <Image
              src={ImageExplainer}
              alt="installation explainer image"
              className="mx-1 my-3 install-explainer-image"
            />
          </div>
        </div>
        <FixedFooter className="px-3">
          <FilledButton
            fullwidth
            size={ButtonSizes.MD}
            onClick={() => onHideParent?.()}
          >
            Continue to sign up
          </FilledButton>
        </FixedFooter>
      </div>
    </BottomModal>
  );
}

export default AppIsDownloadingModal;
